import { extractStringValueSet } from './extract-properties';

export default class EdgeTranslateVersion {
    /* eslint-disable camelcase */
    static readonly v1_0_0: string = 'v1.0.0';
    static readonly v1_4_2: string = 'v1.4.2';
    static readonly v1_5_0: string = 'v1.5.0';
    static readonly v1_5_1: string = 'v1.5.1';
    static readonly v1_5_2: string = 'v1.5.2';
    static readonly v1_5_3: string = 'v1.5.3';
    static readonly v2_0_0: string = 'v2.0.0';
    static readonly FLATIRON_AWAITING_SPECIMEN: string = "v1.0.0+flatiron.awaiting-specimen"
    static readonly FLATIRON_IN_PROGRESS: string = "v1.0.0+flatiron.in-progress"
    static readonly FLATIRON_COMPLETE: string = "v1.0.0+flatiron.complete"
    static readonly FLATIRON_CANCELED: string = "v1.0.0+flatiron.canceled"
    static readonly FLATIRON_DELAYED: string = "v1.0.0+flatiron.delayed"
    static readonly FLATIRON_ON_HOLD: string = "v1.0.0+flatiron.on-hold"
    static readonly FLATIRON_QNS: string = "v1.0.0+flatiron.qns"

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {
        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
